<template>
    <div class="layout-right">
        <div class="layout-right-top">
            <right-top bread="会员中心-会员管理"></right-top>
        </div>
        <div class="layout-right-body">
            <div class="item-box item-search">
                <search-box placeholder="手机号/姓名首字母/姓名" :select-data="selectVipData" :btns="searchOtherBtn" @click="addEvent" @search="searchEvent"></search-box>
            </div>

            <div class="item-content" ref="itemContent">
                <div class="table-box">
                    <el-table :data="tableData" size="medium" ref="tableData" cell-class-name="table-ceil"
                              header-cell-class-name="table-ceil"
                    >
                        <el-table-column prop="nickname" label="姓名" min-width="90">
                            <template slot-scope="data">
                                {{data.row.name}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="sex" label="性别" width="50">
                            <template slot-scope="data">
                                <span v-if="data.row.sex == 1">男</span>
                                <span v-else-if="data.row.sex == 2">女</span>
                                <span v-else>无</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="mobile" label="联系电话" width="110"></el-table-column>
                        <el-table-column prop="money" label="余额(元)" width="90"></el-table-column>
                        <el-table-column prop="vip_name" label="会员等级" width="80">
                            <template slot-scope="data">
                                {{data.row.vip_name ? data.row.vip_name : "无"}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="birthday_type" label="生日类型" width="80">
                            <template slot-scope="data">
                                {{data.row.birthday_type == "1" ? "公历" : (data.row.birthday_type == "2" ? "农历" : "")}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="birthday" label="生日日期" width="95"></el-table-column>
                        <el-table-column prop="create_datetime" label="加入时间" min-width="90"></el-table-column>
                        <el-table-column prop="last_cost_datetime" label="最后消费时间" min-width="90">
                            <template slot-scope="data">
                                <span v-if="data.row.last_cost_datetime">{{data.row.last_cost_datetime}}</span>
                                <span v-else>无</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="操作" size="200" align="right" min-width="200">
                            <template slot-scope="data">
                                <div class="action-box">
                                    <el-button type="text" size="medium" @click="handlePay(data.$index, data.row)">充值</el-button>&nbsp;|&nbsp;
                                    <el-dropdown trigger="click" @command="handleCommand">
                                        <el-button size="medium" type="text">记录<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item :command="'saleHistory:'+data.$index">消费记录</el-dropdown-item>
                                            <el-dropdown-item :command="'rechargeHistory:'+data.$index">充值记录</el-dropdown-item>
                                            <el-dropdown-item :command="'cardHistory:'+data.$index">卡项记录</el-dropdown-item>
                                            <el-dropdown-item :command="'storeUserExtendData:'+data.$index">续费记录</el-dropdown-item>
                                            <el-dropdown-item :command="'storeUserGiveHistory:'+data.$index">赠送记录</el-dropdown-item>
                                            <el-dropdown-item :command="'storeUserChangeMoneyHistory:'+data.$index">调账记录</el-dropdown-item>
                                            <el-dropdown-item :command="'storeUserMoneyData:'+data.$index">余额对账</el-dropdown-item>
                                            <el-dropdown-item :command="'storeUserScoreHistory:'+data.$index">积分记录</el-dropdown-item>
                                            <el-dropdown-item :command="'storeUserArrearsHistory:'+data.$index">欠还记录</el-dropdown-item>
                                            <el-dropdown-item :command="'wechatBindHistory:'+data.$index">绑定记录</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>|
                                    <el-dropdown trigger="click" @command="handleCommand">
                                        <el-button size="medium" type="text">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item :command="'editStoreUser:'+data.$index">修改资料</el-dropdown-item>
                                            <el-dropdown-item :command="'setPayPassword:'+data.$index">修改密码</el-dropdown-item>
                                            <el-dropdown-item :command="'seePayPassword:'+data.$index">查看密码</el-dropdown-item>
                                            <el-dropdown-item :command="'seeStoreBindCode:'+data.$index">查看绑定码</el-dropdown-item>
                                            <el-dropdown-item :command="'storeUserExtend:'+data.$index">会员续费</el-dropdown-item>
                                            <el-dropdown-item :command="'storeUserShow:'+data.$index">会员详情</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>|
                                    <el-dropdown trigger="click" @command="handleCommand">
                                        <el-button size="medium" type="text">高级<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item :command="'deleteStoreUser:'+data.$index">删除</el-dropdown-item>
                                            <el-dropdown-item :command="'changeMoney:'+data.$index">调账</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div class="layout-right-bottom">
            <!--右下-->
            <div class="page-box">
                <el-pagination
                        @size-change="pageSizeChange"
                        @current-change="pageCurrentChange"
                        :current-page="page.nowPage"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="slot, total, sizes, prev, pager, next, jumper"
                        :total="page.count">
                        <div class="all-money">合计余额 {{allMoney}} 元，</div>
                </el-pagination>
            </div>
        </div>

        <!--充值-->
        <pay-money v-model="payBoxShow" :store-uid="payUserInfo.id" @settleOver="loadListData" />

        <!--消费记录-->
        <store-user-sale-history v-model="storeUserSaleHistoryShow" :store-uid="storeUid" />
        <!--充值记录-->
        <store-user-recharge-history v-model="storeUserRechargeHistoryShow" :store-uid="storeUid" />
        <!--续费记录-->
        <store-user-extend-data v-model="storeUserExtendDataShow" :store-uid="storeUid" />
        <!--赠送记录-->
        <store-user-give-history v-model="storeUserGiveHistoryShow" :store-uid="storeUid" />
        <!--调账记录-->
        <store-user-change-money-history v-model="storeUserChangeMoneyHistoryShow" :store-uid="storeUid" />
        <!--会员对账-->
        <store-user-money-data v-model="storeUserMoneyDataShow" :store-uid="storeUid" />
        <!--积分记录-->
        <store-user-score-history v-model="storeUserScoreHistoryShow" :store-uid="storeUid" />
        <!--卡项记录-->
        <card-sale-history-for-cash v-model="cardHistoryShow" :store-uid="storeUid" />
        <!--绑定记录-->
        <store-user-bind-history v-model="wechatBindHistoryShow" :store-uid="storeUid" />
        <!--欠还记录-->
        <store-user-arrears-history v-model="storeUserArrearsHistoryShow" :store-uid="storeUid" />

        <!--修改顾客-->
        <store-user-edit v-model="editShow" :store-uid="storeUid" @changeData="loadListData()" />
        <!--修改消费密码-->
        <set-pay-password v-model="setPayPasswordShow" :store-uid="storeUid" />
        <!--查看消费密码-->
        <see-pay-password v-model="seePayPasswordShow" :store-uid="storeUid" />
        <!--会员续期-->
        <store-user-extend v-model="storeUserExtendShow" :user-info="storeUser" @onOver="loadListData()" />

        <!--调账-->
        <store-user-change-money v-model="storeUserChangeMoneyShow" :store-uid="storeUid" @changeEvent="loadListData" />

        <!--绑定码-->
        <StoreUserBindCode v-model="bindCodeShow" :store-uid="storeUid" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import Menu from "@/model/Menu";
    import SearchBox from "@/model/SearchBox";
    import PopForm from "@/model/PopForm";
    import PayMoneyBox from "@/model/PayMoneyBox";
    import RightTop from "@/model/RightTop";
    import StoreUserEdit from "@/model/StoreUser/StoreUserEdit";
    import PayMoney from "@/model/Cash/PayMoney";
    import StoreUserSaleHistory from "@/model/StoreUser/StoreUserSaleHistory";
    import StoreUserRechargeHistory from "@/model/StoreUser/StoreUserRechargeHistory";
    import StoreUserExtendData from "@/model/StoreUser/StoreUserExtendData";
    import StoreUserGiveHistory from "@/model/StoreUser/StoreUserGiveHistory";
    import StoreUserMoneyData from "@/model/StoreUser/StoreUserMoneyData";
    import SetPayPassword from "@/model/StoreUser/SetPayPassword";
    import SeePayPassword from "@/model/StoreUser/SeePayPassword";
    import StoreUserExtend from "@/model/StoreUser/StoreUserExtend";
    import StoreUserChangeMoney from "@/model/StoreUser/StoreUserChangeMoney";
    import StoreUserChangeMoneyHistory from "@/model/StoreUser/StoreUserChangeMoneyHistory";
    import StoreUserScoreHistory from "@/model/StoreUser/StoreUserScoreHistory";
    import CardSaleHistoryForCash from "@/model/Card/CardSaleHistoryForCash";
    import StoreUserBindHistory from "@/model/StoreUser/StoreUserBindHistory";
    import StoreUserBindCode from "@/model/StoreUser/StoreUserBindCode";
    import StoreUserArrearsHistory from "@/model/StoreUser/StoreUserArrearsHistory";
    export default {
        name: "UserList",
        components: {
            StoreUserArrearsHistory,
            StoreUserBindCode,
            StoreUserBindHistory,
            CardSaleHistoryForCash,
            StoreUserScoreHistory,
            StoreUserChangeMoneyHistory,
            StoreUserChangeMoney,
            StoreUserExtend,
            SeePayPassword,
            SetPayPassword,
            StoreUserMoneyData,
            StoreUserGiveHistory,
            StoreUserExtendData,
            StoreUserRechargeHistory,
            StoreUserSaleHistory, PayMoney, StoreUserEdit, RightTop, PayMoneyBox, PopForm, SearchBox, Menu},
        data: () => ({
            tableAttr:{
                width: "100%",
                height: "100%"
            },
            tableData: [],
            allMoney: "0.00",
            page: {
                nowPage: 1,
                pageSize: 20,
                pageSizes: [20, 50, 100, 200],
                count: 0,
            },
            postData: {},
            searchOtherBtn: [
                {
                    label: "添加会员"
                }
            ],
            selectVipData: {
                value: "",
                listData: []
            },

            storeUid: "",
            storeUser: {},

            storeUserSaleHistoryShow: false,
            storeUserRechargeHistoryShow: false,
            storeUserExtendDataShow: false,
            storeUserGiveHistoryShow: false,
            storeUserMoneyDataShow: false,
            setPayPasswordShow: false,
            seePayPasswordShow: false,
            storeUserExtendShow: false,
            storeUserChangeMoneyShow: false,
            storeUserChangeMoneyHistoryShow: false,
            editShow: false,
            storeUserScoreHistoryShow: false,
            cardHistoryShow: false,
            wechatBindHistoryShow: false,
            bindCodeShow: false,
            storeUserArrearsHistoryShow: false,

            payUserInfo: {},
            payBoxShow: false,

            vip_list: []
        }),
        mounted: function(){
            this.$store.commit("setMenuId", "5-2");

            this.loadVipList();
            this.loadListData();

        },
        methods: {
            //添加按钮点击
            addEvent: function () {
                this.storeUid = null;
                this.editShow = true;
            }

            //修改资料
            ,editSubmit: function () {
                let postData = {
                    store_user_id: this.editData.store_user_id,
                    record: this.editData.record,
                    vip_id: this.editData.vip_id,
                    birthday_type: this.editData.birthday_type,
                    birthday: this.editData.birthday,
                    sex: this.editData.sex,
                    password: this.editData.new_password,
                };
                obj.postData("manage/store_user/set_store_user_info", postData, res => {
                    if(res.errcode !== 0){
                        obj.message.error(res.errdesc);
                    }

                    this.editShow = false;
                    this.loadListData();
                });
            }

            //搜索事件
            ,searchEvent: function (data) {
                this.postData.keyword = data.keyword ? data.keyword : "";
                this.postData.vip_id = data.selectVal ? data.selectVal : "";
                this.loadListData();
            }

            //每页显示数量变化
            ,pageSizeChange: function (val) {
                this.page.pageSize = val;
                this.loadListData();
            }

            //当前页码变化
            ,pageCurrentChange: function (val) {
                this.page.nowPage = val;
                this.loadListData();
            }

            //编辑
            ,handleEdit: function (index, data) {
                this.editStoreUid = data.id;
                this.editShow = true;
            }

            //充值
            ,handlePay: function (index, data) {
                this.payUserInfo = data;
                this.payBoxShow = true;
            }

            //删除
            ,handleDelete: function (index, data) {
                obj.messageBox.confirm("你确定要删除会员【"+data.name+"】吗？", "删除警告", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( () => {
                    obj.postData("store_user/delete", {id: data.id}, res => {
                        if(res.errcode === 0) {
                            obj.message.success("删除成功");
                            this.loadListData();
                        }else
                            obj.message.error(res.errdesc);
                    });
                }, ()=>{});
            }

            //加载VIP列表
            ,loadVipList: function () {
                obj.postData("store_vip/get_vip_sort_list", {}, res => {
                    this.vip_list = res.data;
                    let vipListData = [];
                    res.data.forEach(function (v) {
                        vipListData.push({
                            label: v.vip_name,
                            value: v.vip_id
                        });
                    });
                    this.selectVipData = {
                        value: "",
                        listData: vipListData
                    };
                });
            }

            //加载列表数据
            ,loadListData: function () {
                this.postData = Object.assign(this.postData, {
                    offset: this.page.pageSize * (this.page.nowPage - 1),
                    limit: this.page.pageSize,
                });
                obj.postData("store_user/get_store_user_list", this.postData, function (res) {
                    if(res.errcode === 0){
                        this.tableData = res.data.user_list;
                        this.page.count = res.data.count;
                        this.allMoney = res.data.all_money;
                    }else{
                        this.tableData = [];
                    }
                }.bind(this));
            }

            //下拉菜单
            ,handleCommand: function (comText) {
                let comArr = comText.split(":");
                let com = comArr[0];
                let data = this.tableData[comArr[1]];
                this.storeUid = data.id;
                this.storeUser = data;
                switch (com) {
                    //消费记录
                    case "saleHistory":
                        this.storeUserSaleHistoryShow = true;
                        break;
                    //充值记录
                    case "rechargeHistory":
                        this.storeUserRechargeHistoryShow = true;
                        break;
                    //续费记录
                    case "storeUserExtendData":
                        this.storeUserExtendDataShow = true;
                        break;
                    //赠送记录
                    case "storeUserGiveHistory":
                        this.storeUserGiveHistoryShow = true;
                        break;
                    //调账记录
                    case "storeUserChangeMoneyHistory":
                        this.storeUserChangeMoneyHistoryShow = true;
                        break;
                    //余额对账
                    case "storeUserMoneyData":
                        this.storeUserMoneyDataShow = true;
                        break;
                    //修改资料
                    case "editStoreUser":
                        this.editShow = true;
                        break;
                    //设置支付密码
                    case "setPayPassword":
                        this.setPayPasswordShow = true;
                        break;
                    //查看支付密码
                    case "seePayPassword":
                        this.seePayPasswordShow = true;
                        break;
                    //查看绑定码
                    case "seeStoreBindCode":
                        this.bindCodeShow = true;
                        break;
                    //会员续费
                    case "storeUserExtend":
                        this.storeUserExtendShow = true;
                        break;
                    //会员详情
                    case "storeUserShow":
                        this.$root.go("user/user_info_show", {id: this.storeUid}, true);
                        break;
                    //删除会员
                    case "deleteStoreUser":
                        this.handleDelete(comArr[1], this.storeUser);
                        break;
                    //调账
                    case "changeMoney":
                        this.storeUserChangeMoneyShow = true;
                        break;
                    //积分记录
                    case "storeUserScoreHistory":
                        this.storeUserScoreHistoryShow = true;
                        break;
                    //卡项记录
                    case "cardHistory":
                        this.cardHistoryShow = true;
                        break;
                        //绑定记录
                    case "wechatBindHistory":
                        this.wechatBindHistoryShow = true;
                        break;
                        //欠还记录
                    case "storeUserArrearsHistory":
                        this.storeUserArrearsHistoryShow = true;
                        break;
                    default:
                        break;
                }
            }
        }
    }
</script>

<style scoped>
    .layout-right{
        /*min-width: 1180px;*/
    }
    .layout-right-body>.item-search{
        height: 72px;
    }
    .layout-right-body>.item-content>.table-box{
        border-bottom: none;
        background-color: #ffffff;
        overflow:hidden;
        padding: 5px 16px 0;
    }
    .page-box{
        padding: 10px 20px;
        background: #ffffff;
        border-top: 1px solid #ebedf0;
    }
    .layout-right-bottom{
        padding-top: 0px;
    }
    .table-box .avatar{
        border-radius: 5px;
        max-width: 50px;
        max-height: 50px;
    }
    .no-avatar{
        border-radius: 5px;
        width: 50px;
        height: 50px;
        line-height: 50px;
    }
    .el-button{
        margin: 3px;
    }
    .all-money{
        display: inline-block;
        font-weight: normal;
        font-size: 13px;
        line-height: 28px;
        color: #606266;
    }
    .el-dropdown-link {
        cursor: pointer;
        color: #6CB1E1;
    }
    .action-box{
        color: #dadada;
    }
</style>
